import { BodyUpdateAssessmentApiV1AssessmentAssessmentIdPatch } from "@/api/generated/types.gen";

type UpdatableAssessmentField = keyof Omit<
  BodyUpdateAssessmentApiV1AssessmentAssessmentIdPatch,
  "case_id"
>;

export type ClearTranscriptField = {
  field: Extract<
    UpdatableAssessmentField,
    "full_transcript" | "segmented_full_transcript"
  >;
  value: "";
};

/**
 * MDRS-86 — "Delete transcript" clears the transcript rather than hard-deleting
 * the assessment row. Returns the field/value pairs to PATCH (via
 * useUpdateAssessmentField) so both the plain and segmented transcript are
 * blanked. History is preserved server-side by the existing update flow.
 */
export const buildClearTranscriptFields = (): ClearTranscriptField[] => [
  { field: "full_transcript", value: "" },
  { field: "segmented_full_transcript", value: "" },
];
